export interface ResponseData<T> {
  data: T | null;
  expanded?: boolean;
  status: StatusData | StatusDataEnum;
  statusCode?: number | null;
}

export type StatusData = 'success' | 'loading' | 'error' | 'empty';

export enum StatusDataEnum {
  SUCCESS = 'success',
  LOADING = 'loading',
  ERROR = 'error',
  EMPTY = 'empty'
}
